






































import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import {
  IClientAuthProviderData,
  IClientAuthProviderMethods
} from "@/models/providers/clientAuth";

@Component({
  components: {
    "client-auth-provider": () =>
      import("@/components/app/global/auth/clientAuth/clientAuthProvider.vue"),
    "client-auth-register-fields": () =>
      import(
        "@/components/app/global/auth/clientAuth/clientAuthRegisterFields.vue"
      )
  }
})
export default class ClientCompleteRegistrationModal extends Mixins(
  HasValidation
) {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    clientAuthRegisterFields: HTMLFormElement;
  };

  // Variables

  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit({
    $clientAuthData,
    $clientAuthMethods
  }: {
    $clientAuthData: IClientAuthProviderData;
    $clientAuthMethods: IClientAuthProviderMethods;
  }) {
    try {
      this.isProcessing = true;

      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      // Upload any custom images
      await this.$refs.clientAuthRegisterFields.uploadCustomImages(true);
      // Generate fresh reCaptcha token
      $clientAuthData.form.recaptcha_token = await this.$store.dispatch(
        "utils/recaptcha/generateToken",
        "client_register"
      );
      await $clientAuthMethods.completeFullRegistration();

      this.$emit("registration-completed");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
